export default __webpack_public_path__ + "static/media/decorativa3.64014707.jpg";